module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // identity function for calling harmony imports with the correct context

  /******/

  __webpack_require__.i = function (value) {
    return value;
  };
  /******/

  /******/
  // define getter function for harmony exports

  /******/


  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        /******/
        configurable: false,

        /******/
        enumerable: true,

        /******/
        get: getter
        /******/

      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 8);
  /******/
}(
/************************************************************************/

/******/
[
/* 0 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var SET_LIST_MODE = exports.SET_LIST_MODE = 'SET_LIST_MODE';
  var SET_STATUS_MODE = exports.SET_STATUS_MODE = 'SET_STATUS_MODE';
  var FETCH_ACCOUNTS_REQUEST = exports.FETCH_ACCOUNTS_REQUEST = 'FETCH_ACCOUNTS_REQUEST';
  var FETCH_ACCOUNTS_SUCCESS = exports.FETCH_ACCOUNTS_SUCCESS = 'FETCH_ACCOUNTS_SUCCESS';
  var FETCH_ACCOUNTS_FAILURE = exports.FETCH_ACCOUNTS_FAILURE = 'FETCH_ACCOUNTS_FAILURE';
  /***/
},
/* 1 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var SET_LIST_MODE = exports.SET_LIST_MODE = 'SET_LIST_MODE';
  var SET_STATUS_MODE = exports.SET_STATUS_MODE = 'SET_STATUS_MODE';
  var FETCH_DOCUMENTS_SUCCESS = exports.FETCH_DOCUMENTS_SUCCESS = 'FETCH_DOCUMENTS_SUCCESS';
  var FETCH_DOCUMENTS_FAILURE = exports.FETCH_DOCUMENTS_FAILURE = 'FETCH_DOCUMENTS_FAILURE';
  var FETCH_DOCUMENTS_REQUEST = exports.FETCH_DOCUMENTS_REQUEST = 'FETCH_DOCUMENTS_REQUEST';
  var RESET_DOCUMENT_DOWNLOAD = exports.RESET_DOCUMENT_DOWNLOAD = 'RESET_DOCUMENT_DOWNLOAD';
  var FETCH_DOCUMENT_DOWNLOAD_SUCCESS = exports.FETCH_DOCUMENT_DOWNLOAD_SUCCESS = 'FETCH_DOCUMENT_DOWNLOAD_SUCCESS';
  var FETCH_DOCUMENT_DOWNLOAD_FAILURE = exports.FETCH_DOCUMENT_DOWNLOAD_FAILURE = 'FETCH_DOCUMENT_DOWNLOAD_FAILURE';
  var FETCH_DOCUMENT_DOWNLOAD_REQUEST = exports.FETCH_DOCUMENT_DOWNLOAD_REQUEST = 'FETCH_DOCUMENT_DOWNLOAD_REQUEST';
  /***/
},
/* 2 */

/***/
function (module, exports) {
  module.exports = require("@myie/interact");
  /***/
},
/* 3 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _accountActions = __webpack_require__(6);

  var accountActions = _interopRequireWildcard(_accountActions);

  var _documentActions = __webpack_require__(7);

  var documentActions = _interopRequireWildcard(_documentActions);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  var mapDispatchToProps = _extends({}, accountActions, documentActions);

  exports.default = mapDispatchToProps;
  /***/
},
/* 4 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var mapStateToProps = function mapStateToProps(state) {
    var _state$accountsDefini = state.accountsDefinition,
        accountsDefinition = _state$accountsDefini === undefined ? {} : _state$accountsDefini;
    var mode = accountsDefinition.mode,
        status = accountsDefinition.status,
        accounts = accountsDefinition.accounts,
        documents = accountsDefinition.documents,
        downloadedDocument = accountsDefinition.downloadedDocument,
        isFetching = accountsDefinition.isFetching,
        _accountsDefinition$e = accountsDefinition.error,
        error = _accountsDefinition$e === undefined ? null : _accountsDefinition$e;
    return {
      mode: mode,
      status: status,
      accounts: accounts,
      documents: documents,
      downloadedDocument: downloadedDocument,
      isFetching: isFetching,
      error: error
    };
  };

  exports.default = mapStateToProps;
  /***/
},
/* 5 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _accountsDefinition = __webpack_require__(9);

  var _accountsDefinition2 = _interopRequireDefault(_accountsDefinition);

  var _documentsDefinition = __webpack_require__(10);

  var _documentsDefinition2 = _interopRequireDefault(_documentsDefinition);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var accountsDefinition = function accountsDefinition() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];
    var newState = state;
    newState = (0, _accountsDefinition2.default)(newState, action);
    newState = (0, _documentsDefinition2.default)(newState, action);
    return newState;
  };

  exports.default = accountsDefinition;
  /***/
},
/* 6 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.fetchAccountsIfNeeded = exports.shouldFetchAccounts = exports.fetchAccounts = exports.receiveAccounts = exports.failedAccounts = exports.requestAccounts = exports.setStatusMode = exports.setListMode = undefined;

  var _interact = __webpack_require__(2);

  var _accountTypes = __webpack_require__(0);

  var setListMode = exports.setListMode = function setListMode(mode) {
    return {
      type: _accountTypes.SET_LIST_MODE,
      mode: mode,
      isFetching: true,
      error: null
    };
  };

  var setStatusMode = exports.setStatusMode = function setStatusMode(mode) {
    return {
      type: _accountTypes.SET_STATUS_MODE,
      mode: mode,
      isFetching: true,
      error: null
    };
  };

  var requestAccounts = exports.requestAccounts = function requestAccounts() {
    return {
      type: _accountTypes.FETCH_ACCOUNTS_REQUEST,
      isFetching: true,
      error: null
    };
  };

  var failedAccounts = exports.failedAccounts = function failedAccounts(error) {
    return {
      type: _accountTypes.FETCH_ACCOUNTS_FAILURE,
      isFetching: false,
      error: error.message
    };
  };

  var receiveAccounts = exports.receiveAccounts = function receiveAccounts(json) {
    return {
      type: _accountTypes.FETCH_ACCOUNTS_SUCCESS,
      accounts: json,
      isFetching: false,
      error: null
    };
  };

  var fetchAccounts = exports.fetchAccounts = function fetchAccounts() {
    return function (dispatch) {
      dispatch(requestAccounts());
      return fetch(_interact.Connection.baseUrl('accounts') + 'v3.0/getaccountslist', {
        method: 'post',
        headers: _interact.Connection.headers(),
        body: JSON.stringify({})
      }).then(function (response) {
        return _interact.Connection.errored(response);
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        return dispatch(receiveAccounts(json));
      }).catch(function (error) {
        return dispatch(failedAccounts(error));
      });
    };
  };

  var shouldFetchAccounts = exports.shouldFetchAccounts = function shouldFetchAccounts(state) {
    if (!state.accountsDefinition.accounts) {
      return true;
    }

    var expiry = state.accountsDefinition.accounts.ExpiryDate;
    return new Date() > new Date(expiry);
  };

  var fetchAccountsIfNeeded = exports.fetchAccountsIfNeeded = function fetchAccountsIfNeeded() {
    return function (dispatch, getState) {
      if (shouldFetchAccounts(getState())) {
        return dispatch(fetchAccounts());
      }
    };
  };
  /***/

},
/* 7 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.resetDocumentDownload = exports.fetchDocumentDownload = exports.receiveDocumentDownload = exports.failedDocumentDownload = exports.requestDocumentDownload = exports.fetchDocumentsIfNeeded = exports.shouldFetchDocuments = exports.fetchDocuments = exports.receiveDocuments = exports.failedDocuments = exports.requestDocuments = undefined;

  var _interact = __webpack_require__(2);

  var _documentTypes = __webpack_require__(1);

  var requestDocuments = exports.requestDocuments = function requestDocuments() {
    return {
      type: _documentTypes.FETCH_DOCUMENTS_REQUEST,
      isFetching: true,
      error: null
    };
  };

  var failedDocuments = exports.failedDocuments = function failedDocuments(error) {
    return {
      type: _documentTypes.FETCH_DOCUMENTS_FAILURE,
      isFetching: false,
      error: error.message
    };
  };

  var receiveDocuments = exports.receiveDocuments = function receiveDocuments(json) {
    return {
      type: _documentTypes.FETCH_DOCUMENTS_SUCCESS,
      documents: json,
      isFetching: false,
      error: null
    };
  };

  var fetchDocuments = exports.fetchDocuments = function fetchDocuments() {
    return function (dispatch) {
      dispatch(requestDocuments());
      return fetch(_interact.Connection.baseUrl('accounts') + 'v3.0/documents/getdocuments', {
        method: 'post',
        headers: _interact.Connection.headers(),
        body: JSON.stringify({})
      }).then(function (response) {
        return _interact.Connection.errored(response);
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        return dispatch(receiveDocuments(json));
      }).catch(function (error) {
        return dispatch(failedDocuments(error));
      });
    };
  };

  var shouldFetchDocuments = exports.shouldFetchDocuments = function shouldFetchDocuments(state) {
    if (!state.accountsDefinition.documents) {
      return true;
    }

    var expiry = state.accountsDefinition.accounts.ExpiryDate;
    return new Date() > new Date(expiry);
  };

  var fetchDocumentsIfNeeded = exports.fetchDocumentsIfNeeded = function fetchDocumentsIfNeeded() {
    return function (dispatch, getState) {
      if (shouldFetchDocuments(getState())) {
        return dispatch(fetchDocuments());
      }
    };
  };

  var requestDocumentDownload = exports.requestDocumentDownload = function requestDocumentDownload() {
    return {
      type: _documentTypes.FETCH_DOCUMENT_DOWNLOAD_REQUEST,
      isFetching: true,
      error: null
    };
  };

  var failedDocumentDownload = exports.failedDocumentDownload = function failedDocumentDownload(error) {
    return {
      type: _documentTypes.FETCH_DOCUMENT_DOWNLOAD_FAILURE,
      isFetching: false,
      error: error.message
    };
  };

  var receiveDocumentDownload = exports.receiveDocumentDownload = function receiveDocumentDownload(json, documentKey) {
    return {
      type: _documentTypes.FETCH_DOCUMENT_DOWNLOAD_SUCCESS,
      downloadedDocument: json,
      documentKey: documentKey,
      isFetching: false,
      error: null
    };
  };

  var fetchDocumentDownload = exports.fetchDocumentDownload = function fetchDocumentDownload(request) {
    return function (dispatch) {
      dispatch(requestDocumentDownload());
      return fetch(_interact.Connection.baseUrl('accounts') + 'v3.0/documents/getdocument', {
        method: 'post',
        headers: _interact.Connection.headers(),
        body: JSON.stringify(request)
      }).then(function (response) {
        return _interact.Connection.errored(response);
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        return dispatch(receiveDocumentDownload(json, request.DocumentKey));
      }).catch(function (error) {
        return dispatch(failedDocumentDownload(error));
      });
    };
  };

  var resetDocumentDownload = exports.resetDocumentDownload = function resetDocumentDownload() {
    return {
      type: _documentTypes.RESET_DOCUMENT_DOWNLOAD
    };
  };
  /***/

},
/* 8 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.mapDispatchToProps = exports.mapStateToProps = exports.accountsDefinition = undefined;

  var _reducer = __webpack_require__(5);

  var _reducer2 = _interopRequireDefault(_reducer);

  var _mapStateToProps = __webpack_require__(4);

  var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);

  var _mapDispatchToProps = __webpack_require__(3);

  var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.accountsDefinition = _reducer2.default;
  exports.mapStateToProps = _mapStateToProps2.default;
  exports.mapDispatchToProps = _mapDispatchToProps2.default;
  /***/
},
/* 9 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _accountTypes = __webpack_require__(0);

  var accountDefinition = function accountDefinition() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case _accountTypes.SET_LIST_MODE:
        return _extends({}, state, {
          mode: action.mode
        });

      case _accountTypes.SET_STATUS_MODE:
        return _extends({}, state, {
          status: action.mode
        });

      case _accountTypes.FETCH_ACCOUNTS_SUCCESS:
        return _extends({}, state, {
          accounts: action.accounts,
          isFetching: action.isFetching
        });

      case _accountTypes.FETCH_ACCOUNTS_FAILURE:
      case _accountTypes.FETCH_ACCOUNTS_REQUEST:
        return _extends({}, state, {
          isFetching: action.isFetching,
          error: action.error
        });

      default:
        return state;
    }
  };

  exports.default = accountDefinition;
  /***/
},
/* 10 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var _documentTypes = __webpack_require__(1);

  var documentsDefinition = function documentsDefinition() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case _documentTypes.RESET_DOCUMENT_DOWNLOAD:
        return _extends({}, state, {
          downloadedDocument: null
        });

      case _documentTypes.FETCH_DOCUMENTS_SUCCESS:
        return _extends({}, state, {
          documents: action.documents,
          isFetching: action.isFetching
        });

      case _documentTypes.FETCH_DOCUMENTS_FAILURE:
      case _documentTypes.FETCH_DOCUMENTS_REQUEST:
        return _extends({}, state, {
          isFetching: action.isFetching,
          error: action.error
        });

      case _documentTypes.FETCH_DOCUMENT_DOWNLOAD_SUCCESS:
        return _extends({}, state, {
          downloadedDocument: {
            document: action.downloadedDocument,
            documentKey: action.documentKey
          },
          isFetching: action.isFetching
        });

      case _documentTypes.FETCH_DOCUMENT_DOWNLOAD_FAILURE:
      case _documentTypes.FETCH_DOCUMENT_DOWNLOAD_REQUEST:
        return _extends({}, state, {
          isFetching: action.isFetching,
          error: action.error
        });

      default:
        return state;
    }
  };

  exports.default = documentsDefinition;
  /***/
}
/******/
]);